import React, { useEffect } from "react";
import { useConfig } from "../../context/ConfigContext";

const DynamicMeta: React.FC = () => {
  const { configData } = useConfig();
  
  useEffect(() => {
    if (!configData) return;

    // Set dynamic title
    if (configData.site_title) {
      document.title = configData.site_title;
    }

    // Set dynamic favicon
    if (configData.icon) {
      const faviconUrl = configData.icon;
      validateImage(faviconUrl).then((isValid) => {
        if(isValid){
            updateFavicon(faviconUrl);
        }
      });
    }
  }, [configData]);


  const validateImage = async (url: string): Promise<boolean> => {
    try {
      const response = await fetch(url, { method: "HEAD" });
      // Must be a successful response and an image type
      const contentType = response.headers.get("content-type") || "";
      return response.ok && contentType.startsWith("image/");
    } catch (error) {
      console.warn("Invalid favicon link:", url, error);
      return false;
    }
  };

  const updateFavicon = (url: string) => {
    let link = document.querySelector("link[rel*='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    if (link.href !== url) {
      link.href = url;
    }
  };

  return null;
};

export default DynamicMeta;
